module.exports = require("./wae-CH");